import { CSSProperties, FC } from 'react'
import BaseView from '@src/components/BaseView'

type CompanySectionItem = {
  logo: string
  title?: string
  alt?: string
  customImgStyle?: CSSProperties
}

type CompanySectionProps = {
  items: CompanySectionItem[]
  title?: string
  bgColor?: string
  className?: string
}

export const CompanySection: FC<CompanySectionProps> = ({ items, title, bgColor, className }) => {
  const hasTitle = Boolean(title)
  const compactGrid = items.length <= 5
  const titleClassName = compactGrid
    ? 'text-[28px] leading-[36px] md:text-[32px] md:leading-[39px]'
    : 'text-[24px] leading-[31px] md:text-[32px] md:leading-[39px]'

  return (
    <BaseView className="w-full" style={{ backgroundColor: bgColor }}>
      <BaseView
        className={`w-[90%] max-w-[1180px] mx-auto px-4 md:px-8 ${
          hasTitle ? 'py-9 md:py-14' : 'py-7 md:py-10'
        } ${className ?? ''}`}
      >
        {title && (
          <h2 className={`text-center font-semibold text-[#333333] ${titleClassName}`}>
            {title}
          </h2>
        )}

        <div
          className={`mx-auto grid ${compactGrid ? 'grid-cols-2' : 'grid-cols-4'} sm:grid-cols-3 md:grid-cols-4 ${
            compactGrid ? 'xl:grid-cols-5 max-w-[980px]' : 'xl:grid-cols-8 max-w-[1180px]'
          } justify-items-center gap-x-2 gap-y-3 md:gap-x-6 md:gap-y-6 ${hasTitle ? 'pt-7 md:pt-10' : ''}`}
        >
          {items.map((item, index) => {
            const shouldCenterLastItem = compactGrid && items.length % 2 === 1 && index === items.length - 1

            return (
            <div
              key={`${item.logo}-${item.title ?? ''}`}
              className={`w-full ${shouldCenterLastItem ? 'col-span-2 sm:col-span-1' : ''} ${
                compactGrid ? 'max-w-[170px] h-[92px] md:h-[104px] px-5' : 'max-w-[78px] h-[68px] md:max-w-[128px] md:h-[96px] px-1 md:px-3'
              } rounded-[8px] bg-white border border-[#E7E7E7] shadow-[0_8px_24px_rgba(0,0,0,0.04)] py-2 md:py-4 flex flex-col items-center justify-center overflow-hidden`}
            >
              <img
                className={`${
                  compactGrid
                    ? 'max-w-[150px] max-h-[76px]'
                    : 'max-w-[70px] max-h-[50px] md:max-w-[116px] md:max-h-[70px]'
                } w-auto h-auto object-contain scale-[1.18]`}
                src={item.logo}
                alt={item.alt ?? item.title ?? ''}
                style={item.customImgStyle}
              />
            </div>
            )
          })}
        </div>
      </BaseView>
    </BaseView>
  )
}

CompanySection.defaultProps = {
  title: '',
  bgColor: undefined,
  className: '',
}
